import { Injectable } from '@angular/core';
import { EventsBlueprint } from './events-blueprint';
import { generateUUID } from "three/src/math/MathUtils.js";
import { ImageProperties } from 'src/app/state/entities/component-properties-dto/images.properties.dto';
import { Store } from '@ngrx/store';
import { EventsWebsocketService } from '../../../services/entities/events-websocket.service';
import { entityActions } from 'src/app/state/entities/entity.actions';
import { CollisionType, Components, EntityType } from 'src/app/state/entities/entity.model';
import { Vector3 } from 'three';
import { reactionEmojis, ReactionProperties } from 'src/app/state/entities/component-properties-dto/reactions.properties.dto';

@Injectable({
  providedIn: 'root'
})
export class OnlineImageService extends EventsBlueprint{
  override prompt = "onlineimages"
  constructor(
    private store: Store,
    private websocketService: EventsWebsocketService,
  ) {
    super()
  }

  override start(): void {
    const id = generateUUID();
    const id2 = generateUUID();
    const imageProps: ImageProperties[] = [
      {
        fileId: "02b5b7d9-226d-4cfa-a34e-57be9de0c47a",
        description: `This is image: ${id}`,
        userDefined: {
          tags: [],
          users: [],
        },
        inferred: {
          tags: [],
        },
      },
      {
        fileId: "18e29446-a633-4d62-82f3-d4b6a78f3456",
        description: `This is image: ${id}`,
        userDefined: {
          tags: [],
          users: [],
        },
        inferred: {
          tags: [],
        },
      },
    ];
    this.websocketService.dispatch(
      entityActions.netCreated({
        entity: {
          id: id,
          type: EntityType.Image,
          ownerId: "self",
          components: [Components.text, Components.images],
          coord: new Vector3(-2, 0, Math.random() * 50),
          componentProperties: {
            Text: "TLDR: Description for an image goes here. Lorem ipsum dolor sit amet. The quick lazy fox jumped over the brown dog.",
            Images: imageProps,
          },
          collisionType: CollisionType.Obstacle,
          creationDate: new Date(),
        },
      }),
    );
    this.websocketService.dispatch(
      entityActions.netCreated({
        entity: {
          id: id2,
          type: EntityType.Image,
          ownerId: "self",
          components: [Components.text, Components.images],
          coord: new Vector3(4, 0, Math.random() * 50),
          componentProperties: {
            Text: "TLDR: Description for an image goes here. Lorem ipsum dolor sit amet. The quick lazy fox jumped over the brown dog.",
            Images: imageProps,
          },
          collisionType: CollisionType.Obstacle,
          creationDate: new Date(),
        },
      }),
    );
  }

  generateRandomReactionCounters(
    emojis: string[],
    maxCount = 5000,
  ): {[key: string]: number}[] {
    return emojis.slice(0, 4).map((reaction) => ({
      [reaction]: Math.floor(Math.random() * maxCount), // 0..maxCount-1
    }));
  }

  buildReactions(count: number) {
    const reactionsList = reactionEmojis;
    let reactions: ReactionProperties = {
      smallScaleReactions: [],
      commonReactionsCounters: this.generateRandomReactionCounters(
        reactionsList,
        5000,
      ),
    };
    for (let x = 0; x < count; x++) {
      reactions.smallScaleReactions.push({
        userId: "123",
        reaction:
          reactionsList[Math.round(Math.random() * reactionsList.length - 1)],
      });
    }
    return reactions;
  }
}
